import { Masthead } from "../components/Masthead";
import { idx, unitColor } from "../store";

const STATUS: Record<string, [string, string]> = { published: ["good", "raspored objavljen"], partial: ["partial", "djelimičan raspored"], pending: ["partial", "raspored još nije objavljen"], none: ["none", "raspored nije javan"] };

export function UnitsPage() {
  const I = idx.value!;
  document.title = "Fakulteti · Slušam";
  return (
    <>
      <Masthead compact />
      <div class="page">
        <h1 style="font:400 44px/1 var(--display);margin:.2rem 0 1rem">Fakulteti i akademije</h1>
        <table class="plain"><thead><tr><th>Jedinica</th><th>Predmeti</th><th>Termini</th><th>Raspored</th></tr></thead>
          <tbody>{I.core.units.map((u) => {
            const n = I.core.courses.filter((c) => c.fac === u.code).length;
            const s = I.core.sessions.filter((x) => I.courses.get(x.course_id)?.fac === u.code).length;
            const [cls, label] = STATUS[u.timetable.status];
            return <tr key={u.code}><td><a href={`/u/${u.code}`} style={`color:${unitColor(u.code)};font-weight:600`}>{u.code}</a> {u.name}</td><td>{n}</td><td>{s}</td><td><span class={`qbadge ${cls}`}>{label}</span> <span class="note">{u.timetable.version} {u.timetable.updated}</span></td></tr>;
          })}</tbody></table>
      </div>
    </>
  );
}

export function UnitPage({ code }: { code: string }) {
  const I = idx.value!;
  const u = I.units.get(code);
  if (!u) return <><Masthead compact /><div class="page"><p class="empty">Jedinica nije pronađena.</p></div></>;
  document.title = `${u.name} · Slušam`;
  const cs = I.core.courses.filter((c) => c.fac === code);
  const depts = new Map<string, number>();
  for (const c of cs) { const d = c.department || "-"; depts.set(d, (depts.get(d) || 0) + 1); }
  const [cls, label] = STATUS[u.timetable.status];
  return (
    <>
      <Masthead compact />
      <div class="page" style={`--c:${unitColor(code)}`}>
        <div class="crumbs"><a href="/u">Fakulteti</a> / {code}</div>
        <h1 style={`font:400 46px/1.05 var(--display);margin:.2rem 0;color:${unitColor(code)}`}>{u.name}</h1>
        {u.name_en && <p class="en" style="font:italic 20px var(--display);color:var(--ink-3);margin:0 0 .6rem">{u.name_en}</p>}
        <p>{u.address} · <a href={`https://www.openstreetmap.org/?mlat=${u.lat}&mlon=${u.lng}#map=17/${u.lat}/${u.lng}`} target="_blank" rel="noopener">karta ↗</a> · <a href={u.site} target="_blank" rel="noopener">{u.site.replace(/^https?:\/\//, "")} ↗</a></p>
        <p><span class={`qbadge ${cls}`}>{label}</span> {u.timetable.version && <span class="note">verzija {u.timetable.version}, {u.timetable.updated}</span>} {u.timetable.url && <a href={u.timetable.url} target="_blank" rel="noopener">izvor ↗</a>}</p>
        {u.timetable.note && <p class="note">{u.timetable.note}</p>}
        {u.email_pattern && <p class="note">Obrazac email adresa: <code>{u.email_pattern}</code></p>}
        <h3 style="font:500 22px var(--display);margin-top:1.4rem">Odsjeci i programi</h3>
        <table class="plain"><tbody>{[...depts.entries()].sort((a, b) => a[0].localeCompare(b[0], "bs")).map(([d, n]) => (
          <tr key={d}><td><a href={`/?fac=${code}&term=&dept=${encodeURIComponent(`${code}|${d}`)}`}>{d}</a></td><td>{n} predmeta</td></tr>
        ))}</tbody></table>
      </div>
    </>
  );
}
